import styled from '@rsos/theme/styled';

export const NotificationPill = styled.div`
  background-color: ${props => props.theme.colors.palette.primary_base};
  font-size: 12px;
  color: ${props => props.theme.colors.palette.background};
  padding: 4px 8px;
  text-transform: uppercase;
  border-radius: 5px;
  width: fit-content;
  font-weight: 700;
  cursor: pointer;
`;
